// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import ReactPaginate from 'react-paginate';

// import {
//     Card,
//     Row,
//     Col,
//     CardTitle,
//     CardBody,
//     Button,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     FormText,
//     Table
// } from "reactstrap";

// const UserMaster = () => {
//     const navigate = useNavigate();
//     const [userTable, setUserTable] = useState([]);
//     const [totalPage, setTotalPage] = useState();

//     const onHandleSearchKeyItem = (e) => {
//         const value = e.target.value;
//         getUserData(1, 10, value)
//     }

//     const onHandleAddUser = () => {
//         navigate("/addUser")
//     }

//     const onHandleEditCategory = (id) => {
//         let findArrayData = userTable.find(e => e.id === id)
//         navigate('/addUser', { state: { userId: findArrayData?.id } });
//     }

//     const getUserData = async (page = 1, limit = 10, search = "") => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             const response = await apiService.get(`api/admin/User_Detail/GetUsers`, config)
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 setUserTable(response.user_DetailData)
//                 // toast.success(response.message);
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//              toast.error(`SomeThing went wrong!!`);
//         }
//     };

//     useEffect(() => {
//         getUserData();
//     }, [!userTable]);

//     const handlePageClick = (data) => {
//         getUserData(data.selected + 1)
//     };

//     const onHandleDeleteUser = async (id) => {

//         const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
//         if (isDeleteConfirmed) {
//             try {
//                 let config = {
//                     headers: {
//                         'Content-Type': 'application/json', // Important for file upload//s
//                         'accept': 'application/json'
//                     }
//                 };

//                 const response = await apiService.delete(`api/admin/User_Detail/delete?id=${id}`, config)
//                 if (response.response && response.response.data.errors) {
//                     toast.error(response.response?.data?.errors);
//                 }

//                 if (response.status === true) {
//                     toast.success(response.message);
//                     getUserData()
//                 }
//                 else {
//                     toast.success(response.message);
//                 }
//             } catch (error) {
//                 console.log(error)
//                  toast.error(`SomeThing went wrong!!`);
//             }
//         } else {
//             console.log('Deletion canceled.');
//         }
//     };

//     return (
//         <>
//             <Col lg="12">
//                 <Card className='bg-white pd-10 card-box mb-30'>
//                     <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
//                         <div className="d-flex align-items-center">
//                             <i className="bi bi-card-text mr-2"></i>
//                             User Master
//                         </div>

//                         <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
//                             <Input   id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
//                         </Row>

//                         <Button color="primary" size="bg" onClick={onHandleAddUser}>Add</Button>
//                     </CardTitle>

//                     <CardBody className="">
//                         <Table striped hover responsive>
//                             <thead>
//                                 <tr>
//                                      <th>S. no.</th>
//                                     <th></th>
//                                     <th>User Name</th>
//                                     <th>Role</th>
//                                     <th>Moblie No.</th>
//                                    <th>Email</th>
//                                     {/* <th>Delete</th> */}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {userTable.length > 0 ? userTable.map((item, index) => (

//                                     <tr key={index}>
//                                         <th scope="row">{index + 1}</th>
//                                         <td>
//                                                 <i className="bi bi-pencil text-primary" style={{cursor:"pointer"}} onClick={() => onHandleEditCategory(item.id)}></i>
//                                         </td>
//                                         <td>{item.user_name}</td>
//                                         <td>{item.user_profile}</td>

//                                         <td>{item.user_mobile}</td>
//                                         <td>{item.user_email}</td>
//                                         {/* <td>
//                                             <Button color="danger" size="bg" onClick={() => onHandleDeleteUser(item.id)}>
//                                                 <i className="bi bi-trash"></i>
//                                             </Button>
//                                         </td> */}
//                                     </tr>
//                                 )) : (
//                                     <tr>
//                                         <td colSpan="6" className="text-center">No users found</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </CardBody>

//                     <CardBody>
//                         {/* <ReactPaginate
//                             previousLabel={'Previous'}
//                             nextLabel={'Next'}
//                             breakLabel={'...'}
//                             breakClassName={'break-me'}
//                             pageCount={totalPage}
//                             marginPagesDisplayed={2}
//                             pageRangeDisplayed={5}
//                             onPageChange={handlePageClick}
//                             containerClassName={'pagination'}
//                             activeClassName={'active'}
//                         /> */}
//                         <ReactPaginate
//                             previousLabel={'Previous'}
//                             nextLabel={'Next'}
//                             breakLabel={'...'}
//                             pageCount={totalPage} // still 4000
//                             marginPagesDisplayed={1} // 1 page at start & end
//                             pageRangeDisplayed={2}  // visible range around selected page
//                             onPageChange={handlePageClick}
//                             containerClassName={'pagination'}
//                             activeClassName={'active'}

//                             pageClassName={'page-item'}
//                             pageLinkClassName={'page-link'}
//                             previousClassName={'page-item'}
//                             nextClassName={'page-item'}
//                             previousLinkClassName={'page-link'}
//                             nextLinkClassName={'page-link'}
//                             breakClassName={'page-item'}
//                             breakLinkClassName={'page-link'}
//                         />
//                     </CardBody>
//                 </Card>
//             </Col>
//         </>
//     )
// }

// export default UserMaster

//SignalR
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import ReactPaginate from 'react-paginate';
// import {
//   Card,
//   Row,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Input,
//   Table,
// } from 'reactstrap';
// import {
//   createAppConnection,
//   subscribeRealtimeUpdate,
//   unsubscribeRealtimeUpdate,
// } from '../../utils/signalRService';

// const UserMaster = () => {
//   const navigate = useNavigate();
//   const [userTable, setUserTable] = useState([]);
//   const [totalPage, setTotalPage] = useState(0);
//   const [searchKey, setSearchKey] = useState('');
//   const mountedRef = useRef(false);

//   const onHandleAddUser = () => {
//     navigate('/addUser');
//   };

//   const onHandleEditCategory = (id) => {
//     let findArrayData = userTable.find((e) => e.id === id);
//     navigate('/addUser', { state: { userId: findArrayData?.id } });
//   };

//   const getUserData = useCallback(async (page = 1, limit = 10, search = '') => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const response = await apiService.get(
//         `api/admin/User_Detail/GetUsers?filter=${encodeURIComponent(search)}`,
//         config,
//       );

//       if (response.response && response.response.data?.errors) {
//         toast.error(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         setUserTable(response.user_DetailData || []);
//         setTotalPage(response.totalPages || 0);
//       } else {
//         setUserTable([]);
//         toast.error(response.message || 'Failed');
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error('SomeThing went wrong!!');
//       setUserTable([]);
//     }
//   }, []);

//   const onHandleSearchKeyItem = (e) => {
//     const value = e.target.value;
//     setSearchKey(value);
//     getUserData(1, 10, value);
//   };

//   const handlePageClick = (data) => {
//     getUserData(data.selected + 1, 10, searchKey);
//   };

//   const onHandleDeleteUser = async (id) => {
//     const isDeleteConfirmed = window.confirm(
//       'Are you sure you want to delete this item?',
//     );
//     if (isDeleteConfirmed) {
//       try {
//         let config = {
//           headers: {
//             'Content-Type': 'application/json',
//             accept: 'application/json',
//           },
//         };

//         const response = await apiService.delete(
//           `api/admin/User_Detail/delete?id=${id}`,
//           config,
//         );

//         if (response.response && response.response.data?.errors) {
//           toast.error(response.response?.data?.errors);
//         }

//         if (response.status === true) {
//           toast.success(response.message);
//           getUserData(1, 10, searchKey);
//         } else {
//           toast.error(response.message);
//         }
//       } catch (error) {
//         console.log(error);
//         toast.error('SomeThing went wrong!!');
//       }
//     }
//   };

//   useEffect(() => {
//     getUserData(1, 10, searchKey);
//   }, [getUserData, searchKey]);

//   useEffect(() => {
//     mountedRef.current = true;

//     const setupSignalR = async () => {
//       try {
//         await createAppConnection();

//         unsubscribeRealtimeUpdate();

//         await subscribeRealtimeUpdate((payload) => {
//           if (!mountedRef.current || !payload) return;

//           const isSameModule = String(payload.module || '') === 'UserMaster';

//           if (isSameModule) {
//             getUserData(1, 10, searchKey);
//           }
//         });
//       } catch (err) {
//         console.error('SignalR error:', err);
//       }
//     };

//     setupSignalR();

//     return () => {
//       mountedRef.current = false;
//     };
//   }, [getUserData, searchKey]);

//   useEffect(() => {
//     return () => {
//       unsubscribeRealtimeUpdate();
//     };
//   }, []);

//   return (
//     <>
//       <Col lg='12'>
//         <Card className='bg-white pd-10 card-box mb-30'>
//           <CardTitle
//             tag='h6'
//             className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
//           >
//             <div className='d-flex align-items-center'>
//               <i className='bi bi-card-text mr-2'></i>
//               User Master
//             </div>

//             <Row
//               className='align-items-center'
//               style={{ marginRight: '10px', width: '300px' }}
//             >
//               <Input
//                 id='search'
//                 name='search'
//                 placeholder='Search...'
//                 type='text'
//                 value={searchKey}
//                 onChange={onHandleSearchKeyItem}
//               />
//             </Row>

//             <Button color='primary' size='bg' onClick={onHandleAddUser}>
//               Add
//             </Button>
//           </CardTitle>

//           <CardBody>
//             <Table striped hover responsive>
//               <thead>
//                 <tr>
//                   <th>S. no.</th>
//                   <th></th>
//                   <th>User Name</th>
//                   <th>Role</th>
//                   <th>Moblie No.</th>
//                   <th>Email</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {userTable.length > 0 ? (
//                   userTable.map((item, index) => (
//                     <tr key={item.id ?? index}>
//                       <th scope='row'>{index + 1}</th>
//                       <td>
//                         <i
//                           className='bi bi-pencil text-primary'
//                           style={{ cursor: 'pointer' }}
//                           onClick={() => onHandleEditCategory(item.id)}
//                         ></i>
//                       </td>
//                       <td>{item.user_name}</td>
//                       <td>{item.user_profile}</td>
//                       <td>{item.user_mobile}</td>
//                       <td>{item.user_email}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan='6' className='text-center'>
//                       No users found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </CardBody>

//           <CardBody>
//             <ReactPaginate
//               previousLabel={'Previous'}
//               nextLabel={'Next'}
//               breakLabel={'...'}
//               pageCount={totalPage}
//               marginPagesDisplayed={1}
//               pageRangeDisplayed={2}
//               onPageChange={handlePageClick}
//               containerClassName={'pagination'}
//               activeClassName={'active'}
//               pageClassName={'page-item'}
//               pageLinkClassName={'page-link'}
//               previousClassName={'page-item'}
//               nextClassName={'page-item'}
//               previousLinkClassName={'page-link'}
//               nextLinkClassName={'page-link'}
//               breakClassName={'page-item'}
//               breakLinkClassName={'page-link'}
//             />
//           </CardBody>
//         </Card>
//       </Col>
//     </>
//   );
// };

// export default UserMaster;
//heena
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Input,
  Table,
} from 'reactstrap';
import {
  createAppConnection,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const UserMaster = () => {
  const navigate = useNavigate();

  const [userTable, setUserTable] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [searchKey, setSearchKey] = useState('');

  const mountedRef = useRef(false);

  const onHandleAddUser = () => {
    navigate('/addUser');
  };

  const onHandleEditCategory = (id) => {
    const findArrayData = userTable.find((e) => e.id === id);
    navigate('/addUser', { state: { userId: findArrayData?.id } });
  };

  const getUserData = useCallback(async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/admin/User_Detail/GetUsers?filter=${encodeURIComponent(search)}`,
        config,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setUserTable(response.user_DetailData || []);
        setTotalPage(response.totalPages || 0);
      } else {
        setUserTable([]);
        toast.error(response.message || 'Failed');
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
      setUserTable([]);
    }
  }, []);

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    getUserData(1, 10, value);
  };

  const handlePageClick = (data) => {
    getUserData(data.selected + 1, 10, searchKey);
  };

  const onHandleDeleteUser = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );

    if (!isDeleteConfirmed) return;

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.delete(
        `api/admin/User_Detail/delete?id=${id}`,
        config,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        getUserData(1, 10, searchKey);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  useEffect(() => {
    getUserData(1, 10, searchKey);
  }, [getUserData, searchKey]);

  useEffect(() => {
    mountedRef.current = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mountedRef.current || !payload) return;

          const isSameModule = String(payload.module || '') === 'UserMaster';

          if (isSameModule) {
            getUserData(1, 10, searchKey);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    setupSignalR();

    return () => {
      mountedRef.current = false;
    };
  }, [getUserData, searchKey]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();
    };
  }, []);

  return (
    <>
      <Col lg='12'>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-card-text mr-2'></i>
              User Master
            </div>

            <Row
              className='align-items-center'
              style={{ marginRight: '10px', width: '300px' }}
            >
              <Input
                id='search'
                name='search'
                placeholder='Search...'
                type='text'
                value={searchKey}
                onChange={onHandleSearchKeyItem}
              />
            </Row>

            <Button color='primary' size='bg' onClick={onHandleAddUser}>
              Add
            </Button>
          </CardTitle>

          <CardBody>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>S. no.</th>
                  <th></th>
                  <th>User Name</th>
                  <th>Role</th>
                  <th>Designation</th>
                  <th>Salary</th>
                  <th>Leave Allowed</th>
                  <th>Mobile No.</th>
                  <th>Email</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {userTable.length > 0 ? (
                  userTable.map((item, index) => (
                    <tr key={item.id ?? index}>
                      <th scope='row'>{index + 1}</th>

                      <td>
                        <i
                          className='bi bi-pencil text-primary'
                          style={{ cursor: 'pointer' }}
                          onClick={() => onHandleEditCategory(item.id)}
                        ></i>
                      </td>

                      <td>{item.user_name}</td>
                      <td>{item.user_profile}</td>

                      <td>{item.designation || ''}</td>

                      <td>
                        {item.salary_amount !== null &&
                        item.salary_amount !== undefined
                          ? Number(item.salary_amount).toFixed(2)
                          : '0.00'}
                      </td>

                      <td>{item.leave_allowed ?? ''}</td>

                      <td>{item.user_mobile}</td>
                      <td>{item.user_email}</td>

                      <td>
                        <i
                          className='bi bi-trash text-danger'
                          style={{ cursor: 'pointer' }}
                          onClick={() => onHandleDeleteUser(item.id)}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan='10' className='text-center'>
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>

          <CardBody>
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={totalPage}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
            />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default UserMaster;
